import { filterNotEmpty } from 'src/utils/data/listHelpers';
import {
  CustomObject,
  DataTableObject
} from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CustomObject.types';
import { StatusModel } from 'src/graphql/types';

export const convertCustomObjectToDataTableObject = (data: Array<CustomObject> | undefined): DataTableObject[] => {
  const customObjects = filterNotEmpty(data) ?? [];
  return customObjects.map((customObject) => {
    return {
      uid: customObject.uid ?? '',
      name: customObject.name ?? '',
      description: customObject.description ?? '',
      status: customObject.status ?? StatusModel.Active,
      referenceId: customObject.referenceId ?? '',
      referenceCode: customObject.referenceCode ?? ''
    };
  });
};
